import Header from '../components/Main/Header';
import Content from '../components/Main/Content';

import '../assets/styles/bidder.scss';

export default function AuthLayout({ children, title, renderHeaderContentCallback = null }) {
  return (
    <>
      <div className={'bidder-wrapper'}>
        <Header
          title={title}
          hasUser={true}
          renderHeaderContentCallback={renderHeaderContentCallback}
        />
        <Content>{children}</Content>
      </div>
    </>
  );
}
